// extracted by mini-css-extract-plugin
export default {"modalText":"ModalEvSearchInfo_modalText__0woaJ"};